export default __webpack_public_path__ + "static/media/h7.78719005.jpg";